import { AUTH_ENDPOINTS } from "./auth";
import { SERVER_ENDPOINTS } from "./server";
import { API_KEY_ENDPOINTS } from "./api-key";
import { USER_ENDPOINTS } from "./user";
import { PROCESS_LOGS_ENDPOINTS } from "./process-logs";
import { SYSTEM_INFO_ENDPOINTS } from "./system-info";
import { SERVER_GROUPS_ENDPOINTS } from "./server-goups";
import { SERVER_FEATURES_ENDPOINTS } from "./server-features";
import { MODALS_ENDPOINTS } from "./modals";
import { REQUEST_LOGS_ENDPOINTS } from "./request-logs";

export const UNIVERSAL_AI_ENDPOINTS = {
  auth: AUTH_ENDPOINTS,
  api_keys: API_KEY_ENDPOINTS,
  server: SERVER_ENDPOINTS,
  modals: MODALS_ENDPOINTS,
  server_groups: SERVER_GROUPS_ENDPOINTS,
  server_features: SERVER_FEATURES_ENDPOINTS,
  system_info: SYSTEM_INFO_ENDPOINTS,
  user: USER_ENDPOINTS,
  process_logs: PROCESS_LOGS_ENDPOINTS,
  request_logs: REQUEST_LOGS_ENDPOINTS,
}